export default "__VITE_ASSET__DJ8mVikT__"